import React from 'react';
import classnames from 'classnames';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import bindOwnClassnamesWithSkin from '@wix/da-shared-react/pkg/utils/bindOwnClassnamesWithSkin';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';

import s from './ConfigPopover.scss';

export interface Props {
  width?: number;
  withPaddings?: boolean;
  className?: string;
  skin?: { [k: string]: string };
  onClose(): void;
}

const ConfigPopover: React.FC<Props> = ({
  width,
  withPaddings = true,
  skin = {},
  className,
  onClose,
  children,
}) => {
  const styles = bindOwnClassnamesWithSkin(s, skin);

  return (
    <PositionOnlyPopperPopover
      popoverContent={
        <ThemeOverride
          className={classnames('no-theme-skin', styles('theme-wrapper'))}
          theme={ThemeOptions.LIGHT}
        >
          {children}
        </ThemeOverride>
      }
      width={width}
      onClickOutside={onClose}
      className={s['ref-style']}
      wrapperClassName={classnames(
        'no-theme-skin',
        styles('tooltip-wrapper'),
        className
      )}
      contentClassName={classnames(
        styles('tooltip-content'),
        withPaddings && styles('with-paddings')
      )}
      placement="bottom"
      secondaryPlacement="end"
      usePortal={false}
    />
  );
};
ConfigPopover.displayName = 'ConfigPopover';

export default ConfigPopover;
